import { render } from "./CompraFormulario.vue?vue&type=template&id=196e260d&scoped=true"
import script from "./CompraFormulario.vue?vue&type=script&lang=js"
export * from "./CompraFormulario.vue?vue&type=script&lang=js"

import "./CompraFormulario.vue?vue&type=style&index=0&id=196e260d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196e260d"]])

export default __exports__